import Profile from ".";

export const profileRoutes = (data) => [
  {
    path: "/:lang/admin/profile",
    title: "profile",
    layout: "admin",
    routeType: "admin",
    component: Profile,
  },
];
